import React, { FC } from "react";
import { TableCell, TableRow } from "@mui/material";
import { CenterRadiologist } from "./useCenterRadiologists";
import { RadiologistCutoff } from "./useRadiologistCutoffs";
import { CutoffSelectValue } from "./useCalendarEditState";
import { DayColumn } from "./types";
import CutoffSelect from "./CutoffSelect";
import CutoffStatusChip from "./CutoffStatusChip";

type Props = {
  radiologist: CenterRadiologist;
  dayColumns: DayColumn[];
  cutoffs: RadiologistCutoff[];
  isEditMode: boolean;
  isEditable: boolean;
  getValue: (userId: string, dateISO: string) => CutoffSelectValue;
  setValue: (userId: string, dateISO: string, value: CutoffSelectValue) => void;
  getDisabledValues: (dateISO: string) => string[];
  getSlotBounds: (dateISO: string) => { slotStart: number; slotEnd: number };
  nameCell: string;
  bodyCell: string;
};

const AvailabilityTableRow: FC<Props> = ({
  radiologist,
  dayColumns,
  cutoffs,
  isEditMode,
  isEditable,
  getValue,
  setValue,
  getDisabledValues,
  getSlotBounds,
  nameCell,
  bodyCell,
}) => (
  <TableRow>
    <TableCell className={nameCell}>
      {`${radiologist.firstName} ${radiologist.lastName}`}
    </TableCell>
    {dayColumns.map((col) => {
      const cutoff = cutoffs.find(
        (c) => c.centerUserId === radiologist.id && c.date === col.dateISO,
      );
      return (
        <TableCell key={col.dayNum} className={bodyCell}>
          {isEditMode && isEditable ? (
            <CutoffSelect
              value={getValue(radiologist.id, col.dateISO)}
              onChange={(value) => setValue(radiologist.id, col.dateISO, value)}
              disabledValues={getDisabledValues(col.dateISO)}
              {...getSlotBounds(col.dateISO)}
            />
          ) : (
            <CutoffStatusChip cutoff={cutoff} />
          )}
        </TableCell>
      );
    })}
  </TableRow>
);

export default AvailabilityTableRow;
